export interface AnimeArticle {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  featured: boolean;
  rating: number;
}

export interface AnimeCategory {
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  role: string;
  content: string;
  rating: number;
}

export const categories: AnimeCategory[] = [
  {
    name: '热血战斗',
    slug: 'rexue-zhandou',
    icon: 'ri-sword-line',
    description: '激情澎湃的战斗场面，热血沸腾的冒险故事',
    count: 128,
  },
  {
    name: '玄幻修仙',
    slug: 'xuanhuan-xiuxian',
    icon: 'ri-magic-line',
    description: '仙侠世界的奇幻冒险，修炼成仙的传奇之路',
    count: 156,
  },
  {
    name: '搞笑日常',
    slug: 'gaoxiao-richang',
    icon: 'ri-emotion-laugh-line',
    description: '轻松愉快的日常故事，欢乐不断的搞笑佳作',
    count: 94,
  },
  {
    name: '科幻机甲',
    slug: 'kehuan-jijia',
    icon: 'ri-rocket-line',
    description: '未来科技与机甲战斗，探索宇宙的无限可能',
    count: 73,
  },
  {
    name: '悬疑推理',
    slug: 'xuanyi-tuili',
    icon: 'ri-search-eye-line',
    description: '扑朔迷离的案件推理，扣人心弦的悬疑故事',
    count: 58,
  },
  {
    name: '恋爱校园',
    slug: 'lianai-xiaoyuan',
    icon: 'ri-heart-line',
    description: '青春校园的甜蜜恋爱，成长路上的温暖相伴',
    count: 112,
  },
  {
    name: '古风国漫',
    slug: 'gufeng-guoman',
    icon: 'ri-building-2-line',
    description: '中华传统文化为背景的国产动漫精品',
    count: 89,
  },
  {
    name: '冒险奇幻',
    slug: 'maoxian-qihuan',
    icon: 'ri-compass-3-line',
    description: '异世界冒险与奇幻旅程，突破想象的边界',
    count: 67,
  },
];

export const articles: AnimeArticle[] = [
  {
    id: 'doupo-cangqiong-nianfan',
    title: '斗破苍穹年番：萧炎突破斗宗，美杜莎女王惊艳登场',
    excerpt: '《斗破苍穹》年番最新剧情迎来重大转折，萧炎在历经数次生死磨炼后终于突破至斗宗境界，而美杜莎女王的惊艳亮相更是让粉丝们热血沸腾。本集制作水准再创新高，特效与剧情同步升级。',
    content: `<p>《斗破苍穹》年番自开播以来，一直保持着极高的制作水准和稳定的更新节奏，成为国产动漫领域的标杆之作。在最新一集中，萧炎终于迎来了期待已久的实力突破。</p>
<p>经过与魂殿强者的殊死搏斗，萧炎在生死一线间领悟了更高层次的斗气运用，成功踏入斗宗境界。这一突破不仅意味着实力的质变，更标志着他在整个斗气大陆的地位得到了根本性的提升。</p>
<p>本集中美杜莎女王的出场场景堪称经典，制作团队在角色建模和动作设计上投入了大量心血，每一帧都展现出了女王的高贵与威严。她与萧炎之间的互动也为后续剧情埋下了重要伏笔。</p>
<p>从画面表现来看，特效团队在斗气化翼、能量对撞等场景的处理上有了明显进步，光影效果更加自然流畅，色彩搭配也更加协调。这些细节的提升让整部作品的质量再上一个台阶。</p>
<p>作为国产动漫年番的代表作，《斗破苍穹》不仅在剧情上保持着对原著的忠实还原，更在动画制作上不断突破自我，为国产动漫树立了新的行业标准。</p>`,
    category: '玄幻修仙',
    categorySlug: 'xuanhuan-xiuxian',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20anime%20style%20art%2C%20young%20warrior%20with%20flame%20powers%20floating%20in%20air%2C%20dark%20dramatic%20background%20with%20energy%20waves%2C%20martial%20arts%20fantasy%20illustration%2C%20dynamic%20composition%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20high%20quality%20digital%20art%2C%20cinematic%20lighting%2C%20detailed%20character%20design&width=800&height=450&seq=doupo-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-08-03',
    readTime: '8分钟',
    tags: ['斗破苍穹', '萧炎', '美杜莎', '年番', '玄幻'],
    featured: true,
    rating: 9.5,
  },
  {
    id: 'fanren-xiuxian-zhuan-xinji',
    title: '凡人修仙传新季开播：韩立踏入灵界，3D画面全面升级',
    excerpt: '备受期待的《凡人修仙传》新季正式开播，韩立终于踏入灵界开启全新冒险。本季在3D画面上进行了全面技术升级，角色表情更加细腻，场景渲染更加真实，为观众带来沉浸式的修仙体验。',
    content: `<p>《凡人修仙传》作为国产3D动漫的领军作品，新季的开播无疑是近期动漫圈最大的话题之一。韩立经过人界篇的千锤百炼，终于踏入了神秘莫测的灵界。</p>
<p>灵界篇的开启意味着整个故事格局的全面升级。从开篇几集来看，灵界的世界观构建更加宏大，种族设定更加丰富，为后续剧情的发展提供了无限可能。</p>
<p>技术层面，制作团队在新季中引入了全新的渲染引擎，角色皮肤质感、毛发细节、环境光影都得到了显著提升。尤其是韩立的微表情处理，从眼神到嘴角的细微变化都表现得更加自然生动。</p>
<p>战斗场面的设计也达到了新高度，法术特效不再是简单的光效堆砌，而是融入了更多东方美学的意境表达，让每一场战斗都成为视觉享受。</p>
<p>《凡人修仙传》新季的成功开播再次证明，国产3D动漫正在以惊人的速度追赶国际一流水平。</p>`,
    category: '玄幻修仙',
    categorySlug: 'xuanhuan-xiuxian',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20style%2C%20cultivator%20in%20traditional%20robe%20standing%20in%20mystical%20realm%2C%20floating%20islands%20and%20magical%20energy%20currents%2C%20ethereal%20atmosphere%2C%20warm%20golden%20light%20rays%2C%20fantasy%20landscape%2C%20detailed%203D%20character%20render%2C%20cinematic%20composition&width=800&height=450&seq=fanren-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-08-02',
    readTime: '7分钟',
    tags: ['凡人修仙传', '韩立', '灵界', '3D动漫', '修仙'],
    featured: true,
    rating: 9.3,
  },
  {
    id: 'yiren-zhixia-diwuji',
    title: '一人之下第五季完结：张楚岚身世之谜终揭晓，冯宝宝真实身份曝光',
    excerpt: '《一人之下》第五季迎来震撼结局，张楚岚的身世之谜终于揭开面纱，而冯宝宝的真实身份也随之浮出水面。这一季的剧情张力十足，打斗场面酣畅淋漓，被誉为系列最佳季。',
    content: `<p>《一人之下》第五季以一场信息量极大的结局为整个季画上了圆满的句号。作为国产动漫中融合道教文化与现代都市题材的代表作，本季在剧情深度和角色塑造上都达到了新的高度。</p>
<p>张楚岚身世之谜的揭晓是第五季最大的看点。原来他体内流淌的不仅仅是普通异人的血脉，更与甲申之乱的核心秘密有着千丝万缕的联系。这个揭示不仅回答了三季以来观众的核心疑问，更将整个故事推向了新的高潮。</p>
<p>冯宝宝的真实身份也在本季中得到了关键性的揭露。她与无根生的关系、她长生不老的秘密，这些谜团的解开让观众在震惊之余更加敬佩作者在前期埋设伏笔的功力。</p>
<p>本季的打斗场面可以说是系列之最，尤其是最后三集的连续战斗，动作设计行云流水，镜头调度收放自如，充分展现了国产2D动画在动作戏上的顶尖水平。</p>
<p>随着第五季的完结，《一人之下》已经确立了自己在国产动漫中不可撼动的地位。</p>`,
    category: '热血战斗',
    categorySlug: 'rexue-zhandou',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20action%20scene%2C%20two%20characters%20in%20intense%20martial%20arts%20combat%2C%20modern%20urban%20setting%20with%20supernatural%20energy%20effects%2C%20dynamic%20fighting%20pose%2C%20dark%20moody%20lighting%2C%20traditional%20Chinese%20elements%2C%20high%20contrast%20color%20scheme&width=800&height=450&seq=yiren-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-08-01',
    readTime: '10分钟',
    tags: ['一人之下', '张楚岚', '冯宝宝', '异人', '道教'],
    featured: true,
    rating: 9.6,
  },
  {
    id: 'shiguang-dailiren-xinji',
    title: '时光代理人第二季开播：程小时与陆光再携手，穿越时空拯救未来',
    excerpt: '《时光代理人》第二季在粉丝的翘首期盼中终于开播，程小时和陆光再次携手进入照片中的时空，这一次他们面对的是更加复杂的因果链和更加艰难的道德抉择。',
    content: `<p>《时光代理人》第二季继承了第一季独特的时间穿越设定和悬疑氛围，并在故事深度和情感表达上更进一步。程小时和陆光这对搭档的关系在本季中经历了严峻的考验。</p>
<p>新季的剧情从第一季结尾的悬念处自然衔接，程小时需要面对自己穿越行为带来的蝴蝶效应。曾经试图拯救的人、试图改变的事，都在以意想不到的方式反噬着现在。</p>
<p>本季最大的亮点在于对"命运"与"选择"这一主题的深入探讨。每一个穿越任务都不再是简单的"回到过去改变一件事"，而是涉及到更为复杂的道德困境和情感抉择。</p>
<p>画面上，第二季保持了第一季精美的美术风格，都市场景的细节处理、角色表情的细腻变化都体现了制作团队的用心。时空穿越的转场特效也进行了全新设计，更具视觉冲击力。</p>
<p>《时光代理人》用独特的叙事方式证明了国产原创动画的无限可能。</p>`,
    category: '悬疑推理',
    categorySlug: 'xuanyi-tuili',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20mystery%20style%2C%20two%20young%20men%20in%20modern%20city%2C%20clock%20and%20time%20elements%20floating%20around%2C%20mysterious%20atmosphere%2C%20photograph%20transition%20effect%2C%20warm%20but%20melancholic%20color%20tone%2C%20noir%20inspired%20lighting&width=800&height=450&seq=shiguang-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-30',
    readTime: '6分钟',
    tags: ['时光代理人', '程小时', '陆光', '悬疑', '穿越'],
    featured: false,
    rating: 9.4,
  },
  {
    id: 'bailian-cheng-shen-jingcai',
    title: '百炼成神：罗征觉醒上古血脉，九星界终极之战一触即发',
    excerpt: '《百炼成神》最新剧情迎来史诗级高潮，罗征成功觉醒上古盘古血脉，实力暴涨至前所未有的境界。九星界的终极之战即将爆发，各方势力蠢蠢欲动。',
    content: `<p>《百炼成神》作为长篇玄幻动画的代表，一直以宏大的世界观和紧凑的剧情节奏受到观众喜爱。最新篇章中，罗征终于触摸到了上古盘古血脉的奥秘。</p>
<p>觉醒过程的设计堪称精彩，制作团队巧妙地将罗征过往经历的种种磨难与血脉觉醒的契机相融合，让这一刻的到来既有意外之感，又在情理之中。</p>
<p>觉醒后的罗征不仅在战斗力上获得了质的飞跃，更重要的是他对整个九星界的格局有了全新的认知。曾经被视为遥不可及的强者，如今已经近在咫尺。</p>
<p>九星界终极之战的铺垫已经完成，各方势力——圣族、魔族、人族以及其他隐藏种族都将在这一战中亮出底牌。从预告画面来看，这场战斗的规模将是整个系列之最。</p>
<p>《百炼成神》用扎实的制作和不断升级的剧情，为玄幻动漫树立了新的标杆。</p>`,
    category: '玄幻修仙',
    categorySlug: 'xuanhuan-xiuxian',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20fantasy%20warrior%20with%20glowing%20ancient%20power%20aura%2C%20epic%20battle%20scene%2C%20celestial%20energy%20exploding%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20grand%20scale%20composition%2C%20detailed%20armor%20design&width=800&height=450&seq=bailian-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-28',
    readTime: '5分钟',
    tags: ['百炼成神', '罗征', '盘古血脉', '九星界', '热血'],
    featured: false,
    rating: 9.0,
  },
  {
    id: 'quanzhi-gaoshou-dianjing',
    title: '全职高手第三季：叶修率兴欣战队冲击职业联赛，荣耀巅峰之路',
    excerpt: '《全职高手》第三季强势回归，叶修带领兴欣战队正式踏上职业联赛征程。从网吧战队到职业赛场，每一个对手都是新的挑战，每一场比赛都扣人心弦。',
    content: `<p>《全职高手》第三季的开播为国产电竞题材动画注入了新的活力。叶修和兴欣战队的成长故事继续以高质量的制作水准呈现在观众面前。</p>
<p>本季的重点放在了职业联赛的团队配合和个人技术的展现上。每一场比赛都被制作得如同真实电竞比赛的直播一般紧张刺激，让观众仿佛置身于荣耀竞技场。</p>
<p>角色的成长是本季的核心主题。苏沐橙从辅助型选手蜕变为全面的战术核心，唐柔从新人成长为可靠的战力，包子入侵的天赋也在叶修的调教下完全释放。</p>
<p>制作团队在比赛场景的渲染上下足了功夫，技能特效、战术走位、队友配合都被精确地还原出来。尤其是君莫笑千机伞形态切换的流畅度，比前两季有了质的飞跃。</p>
<p>《全职高手》第三季不仅是一部优秀的动画作品，更是国产动漫向多元化题材发展的有力证明。</p>`,
    category: '热血战斗',
    categorySlug: 'rexue-zhandou',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20esports%20style%2C%20competitive%20gaming%20arena%20scene%2C%20team%20of%20gamers%20in%20intense%20match%2C%20cyberpunk%20aesthetic%20with%20holographic%20displays%2C%20dynamic%20action%20composition%2C%20cool%20blue%20and%20warm%20orange%20contrast%2C%20modern%20arena%20atmosphere&width=800&height=450&seq=quanzhi-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    tags: ['全职高手', '叶修', '荣耀', '电竞', '兴欣'],
    featured: true,
    rating: 9.2,
  },
  {
    id: 'shaonian-ge-xing-dajieju',
    title: '少年歌行：萧瑟雷无桀联手抗敌，天启城终局之战震撼上演',
    excerpt: '《少年歌行》迎来全剧最高潮——天启城终局之战。萧瑟、雷无桀、无心等主角团联手对抗最终BOSS，打斗场面恢弘壮阔，情感渲染真挚动人。',
    content: `<p>《少年歌行》作为国产武侠动漫的代表作，天启城终局之战无疑是整部作品最为华彩的篇章。主角团每个人的成长线都在这一刻得到了完美的收束。</p>
<p>萧瑟作为团队的灵魂人物，他的抉择决定了整个战局的走向。从最初不愿展露实力的低调少年，到如今挺身而出守护一切的领袖，萧瑟的成长轨迹令人动容。</p>
<p>雷无桀的枪法在这场战斗中被发挥到了极致，制作团队为他设计了多段极具视觉冲击力的单体战斗，每一枪都充满了力量感和节奏感。</p>
<p>无心的身份反转是终局之战的另一大看点。他隐藏已久的真实面目揭开后，不仅改变了战斗格局，更让观众对整个故事有了全新的理解。</p>
<p>《少年歌行》用一场荡气回肠的终局之战，为国产武侠动漫树立了难以超越的标杆。</p>`,
    category: '古风国漫',
    categorySlug: 'gufeng-guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20anime%20style%2C%20ancient%20Chinese%20city%20battle%20scene%2C%20young%20warriors%20with%20traditional%20weapons%2C%20epic%20scale%20with%20dramatic%20skies%2C%20traditional%20architecture%20background%2C%20dynamic%20combat%20poses%2C%20warm%20sunset%20lighting%2C%20cinematic%20composition&width=800&height=450&seq=shaonian-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-22',
    readTime: '7分钟',
    tags: ['少年歌行', '萧瑟', '雷无桀', '武侠', '天启城'],
    featured: false,
    rating: 9.3,
  },
  {
    id: 'guoman-xinshengdai-pinglun',
    title: '2026年国产动漫新生代力量盘点：这些新秀作品不容错过',
    excerpt: '2026年国产动漫市场涌现出一批令人惊喜的新生代作品。从原创IP到小说改编，从2D手绘到3D渲染，新秀们用实力证明国产动漫的春天已经到来。',
    content: `<p>2026年是国产动漫蓬勃发展的又一年，除了像《斗破苍穹》《凡人修仙传》这样的老牌年番持续发力，一批新生代作品也崭露头角，为市场注入了新鲜血液。</p>
<p>在原创IP方面，《深海回响》《逆流之光》等作品凭借独特的美术风格和新颖的故事设定吸引了大量关注。这些作品没有原著粉丝基础，完全依靠过硬的制作质量打开市场。</p>
<p>小说改编依然是国产动漫的重要来源，但如今的改编已不仅限于玄幻修仙题材。都市异能、历史权谋、科幻末世等多元化题材开始大量涌现，满足了不同观众群体的需求。</p>
<p>技术层面，国产动漫的制作水准持续提升。AI辅助作画、实时渲染引擎等新技术的应用，让中小型制作团队也能产出高质量的作品。</p>
<p>这一批新生代作品的崛起，标志着国产动漫已经进入了一个百花齐放的新阶段。</p>`,
    category: '冒险奇幻',
    categorySlug: 'maoxian-qihuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20collage%20style%2C%20multiple%20anime%20characters%20in%20different%20art%20styles%2C%20vibrant%20colorful%20composition%2C%20showcasing%20diverse%20Chinese%20animation%20art%2C%20modern%20and%20traditional%20fusion%2C%20dynamic%20layout%2C%20bright%20and%20energetic%20atmosphere&width=800&height=450&seq=guoman-new-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-20',
    readTime: '9分钟',
    tags: ['国产动漫', '新生代', '推荐', '盘点', '2026'],
    featured: false,
    rating: 8.8,
  },
  {
    id: 'wulian-fengbao-zuixin',
    title: '雾岚风暴：国产科幻动漫黑马，末世机甲战斗画面惊艳全网',
    excerpt: '《雾岚风暴》这部原创科幻动漫在没有任何预热的情况下突然爆火，其精致的机甲设计、流畅的战斗分镜和深邃的世界观设定让观众眼前一亮，被誉为今年最大黑马。',
    content: `<p>《雾岚风暴》的走红堪称国产动漫圈的一个奇迹。这部没有任何原著IP加持的原创科幻动漫，凭借出色的制作质量和独特的艺术风格，在播出首周就登上了各大平台的热搜榜。</p>
<p>故事设定在一个被名为"雾岚"的神秘物质覆盖的末世世界，人类依靠巨型机甲在残存的陆地板块上艰难求生。主人公林雾是一名年轻的机甲驾驶员，在一次意外任务中发现了"雾岚"背后的惊人真相。</p>
<p>机甲设计是《雾岚风暴》最大的亮点。不同于日式机甲的夸张风格，本作的机甲更注重工业感和真实感，每一个关节、每一块装甲板都有其存在的合理性。战斗场面中的机甲动作也经过了精心设计，既有重工业的厚重感，又不失灵活动感。</p>
<p>在世界观构建上，《雾岚风暴》同样展现出了超越同类作品的深度。末世生存的残酷、人性在极端环境下的抉择、科技与人性的博弈，这些主题被巧妙地编织进了主线剧情中。</p>
<p>《雾岚风暴》的出现证明了国产原创科幻动漫同样可以做到世界级的水准。</p>`,
    category: '科幻机甲',
    categorySlug: 'kehuan-jijia',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20anime%20style%2C%20giant%20mecha%20robot%20in%20post-apocalyptic%20city%2C%20misty%20atmosphere%20with%20industrial%20aesthetic%2C%20detailed%20mechanical%20design%2C%20dramatic%20lighting%20through%20fog%2C%20dark%20and%20moody%20color%20palette%2C%20cinematic%20wide%20shot&width=800&height=450&seq=wulian-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-18',
    readTime: '6分钟',
    tags: ['雾岚风暴', '科幻', '机甲', '原创', '黑马'],
    featured: false,
    rating: 9.1,
  },
  {
    id: 'shiye-zhinan-jiexi',
    title: '食戟之灵国产版？《食业指南》用美食治愈人心，画风温馨获好评',
    excerpt: '《食业指南》这部以中华美食为主题的治愈系动漫近期在社交平台引发热议。精致的食物作画、温暖的剧情和浓郁的中华美食文化底蕴，让无数观众在屏幕前流下了感动与饥饿的泪水。',
    content: `<p>在热血战斗和玄幻修仙占据主流的国产动漫市场，《食业指南》的出现就像一股清流，用食物与温情温柔地叩击着观众的心扉。</p>
<p>故事围绕着一家百年老字号餐馆的年轻继承人陈小满展开。为了重振家族餐馆的声誉，她踏上了学习中华各地传统美食的旅程。从四川的麻辣火锅到广东的精致点心，从陕西的羊肉泡馍到江南的清蒸鲈鱼，每一道菜都是一个故事，每一个故事都承载着一份情感。</p>
<p>食物作画是《食业指南》最令人称道的地方。每一道菜品的呈现都经过精心设计，从食材的质地到烹饪的过程，从出锅的热气到入口的表情，每一个细节都力求还原真实的美食体验。</p>
<p>除了美食本身，作品还深入挖掘了每道菜背后的文化内涵和人情故事。一碗看似普通的牛肉面背后，可能是一个家族三代人的坚守；一盘简单的蛋炒饭里，可能藏着母亲对孩子最深沉的爱。</p>
<p>《食业指南》用美食这个全人类共通的语言，讲述着属于中国人的温暖故事。</p>`,
    category: '搞笑日常',
    categorySlug: 'gaoxiao-richang',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20food%20illustration%2C%20delicious%20traditional%20Chinese%20cuisine%20spread%20on%20table%2C%20warm%20cozy%20restaurant%20interior%2C%20steaming%20hot%20dishes%2C%20soft%20golden%20lighting%2C%20homey%20atmosphere%2C%20detailed%20food%20rendering%2C%20pastel%20warm%20color%20palette&width=800&height=450&seq=shiye-cover-01&orientation=landscape',
    author: '动漫编辑组',
    publishDate: '2026-07-15',
    readTime: '5分钟',
    tags: ['食业指南', '美食', '治愈', '中华料理', '日常'],
    featured: false,
    rating: 8.9,
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: '动漫达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20young%20man%20portrait%2C%20friendly%20smile%2C%20simple%20clean%20background%2C%20casual%20style%2C%20warm%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '资深动漫爱好者',
    content: '51动漫官网是我每天必刷的动漫资讯平台！更新速度超快，文章质量也很高，尤其是对国产动漫的深度解析，让我对很多作品有了全新的理解。强烈推荐给每一位动漫爱好者！',
    rating: 5,
  },
  {
    id: 't2',
    name: '追番少女小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20young%20woman%20portrait%2C%20bright%20smile%2C%20simple%20clean%20background%2C%20modern%20casual%20look%2C%20soft%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '动漫博主',
    content: '作为一个动漫博主，51动漫官网的分类导航做得太方便了！无论是找热血战斗还是玄幻修仙，都能快速定位到想看的内容。网站界面也很清爽，浏览体验一级棒！',
    rating: 5,
  },
  {
    id: 't3',
    name: '老二次元老张',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20middle%20aged%20man%20portrait%2C%20calm%20expression%2C%20simple%20clean%20background%2C%20mature%20look%2C%20professional%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: '动漫行业从业者',
    content: '从事动漫行业十几年了，51动漫官网是我见过的最专业的国产动漫资讯平台。不仅资讯全面，更重要的是分析视角独特，能站在行业高度解读国产动漫的发展趋势。',
    rating: 5,
  },
  {
    id: 't4',
    name: '萌新小白',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20teenager%20portrait%2C%20excited%20expression%2C%20simple%20clean%20background%2C%20youthful%20casual%20style%2C%20bright%20lighting&width=100&height=100&seq=avatar-04&orientation=squarish',
    role: '刚入坑的动漫新人',
    content: '作为刚入坑国产动漫的新人，51动漫官网的分类指南帮我快速找到了适合自己的作品类型。文章写得通俗易懂，没有太多专业术语，对新手超级友好！',
    rating: 5,
  },
];

export const faqData = [
  {
    question: '51动漫官网是什么？',
    answer: '51动漫官网是一个专注于国产动漫的内容平台，提供最新的动漫资讯、深度解析、作品推荐和行业动态。我们致力于为动漫爱好者打造一个高质量的动漫内容社区，帮助大家发现更多优秀的国产动漫作品。',
  },
  {
    question: '51动漫官网的内容多久更新一次？',
    answer: '我们保持每日更新的频率，确保用户能够第一时间获取到最新的国产动漫资讯。热门作品的新集播出后，深度解析文章通常在24小时内发布。同时，每周还会推出专题盘点类内容，帮助大家全面了解国产动漫的最新动态。',
  },
  {
    question: '如何在51动漫官网找到想看的动漫类型？',
    answer: '您可以通过首页顶部的分类导航快速定位感兴趣的类型，也可以在分类页面中按热血战斗、玄幻修仙、搞笑日常、科幻机甲、悬疑推理、恋爱校园、古风国漫、冒险奇幻等维度浏览。每个分类都有详细的作品列表和介绍。',
  },
  {
    question: '51动漫官网的文章可以转载吗？',
    answer: '51动漫官网的所有原创文章均受版权保护。如需转载，请通过关于我们页面的联系方式与我们取得联系，获得书面授权后方可转载。转载时需注明出处并保留原文链接。未经授权的转载行为将被追究法律责任。',
  },
  {
    question: '如何在51动漫官网投稿或提出建议？',
    answer: '我们非常欢迎动漫爱好者的投稿和建议！您可以通过关于我们页面提供的电子邮箱与我们联系，提交您的原创文章或改进建议。我们的编辑团队会在3个工作日内回复您的邮件。优质的投稿将有机会在网站首页展示。',
  },
  {
    question: '51动漫官网有哪些特色功能？',
    answer: '51动漫官网拥有多项特色功能：智能分类导航帮助快速定位感兴趣的类型；热门推荐板块精选每周必看内容；深度解析栏目提供专业的动漫分析；用户评分系统让好作品更容易被发现。我们还持续优化网站体验，为大家提供更好的浏览服务。',
  },
];

export const heroSlides = [
  {
    id: 'slide-1',
    title: '2026国产动漫暑期档',
    subtitle: '热血与感动齐飞 · 经典与新作共舞',
    description: '斗破苍穹年番、凡人修仙传新季、一人之下第五季…… 这个夏天，国产动漫火力全开！',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20anime%20hero%20banner%2C%20group%20of%20powerful%20anime%20characters%20in%20dynamic%20action%20poses%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20gold%20energy%20effects%2C%20cinematic%20composition%2C%20dark%20moody%20background%20with%20sparks%2C%20grand%20epic%20scale%2C%20high%20quality%20digital%20illustration&width=1600&height=800&seq=hero-slide-01&orientation=landscape',
    link: '/article/doupo-cangqiong-nianfan',
  },
  {
    id: 'slide-2',
    title: '国产动漫新生力量崛起',
    subtitle: '原创IP发力 · 技术全面升级',
    description: '雾岚风暴、食业指南等新秀作品惊艳亮相，国产动漫正迎来最好的时代。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20art%20showcase%20banner%2C%20diverse%20anime%20characters%20from%20different%20genres%20united%2C%20vibrant%20colorful%20background%20with%20magical%20particles%2C%20energetic%20and%20inspiring%20atmosphere%2C%20modern%20Chinese%20animation%20style%2C%20cinematic%20wide%20composition%2C%20bright%20and%20dynamic%20lighting&width=1600&height=800&seq=hero-slide-02&orientation=landscape',
    link: '/article/guoman-xinshengdai-pinglun',
  },
  {
    id: 'slide-3',
    title: '古风国漫 · 传承之美',
    subtitle: '少年歌行、秦时明月领衔国风盛宴',
    description: '中华传统文化与现代动画技术的完美融合，每一帧都是壁纸级的视觉享受。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20aesthetic%20anime%20banner%2C%20ancient%20Chinese%20landscape%20with%20flying%20warriors%20in%20silk%20robes%2C%20ink%20wash%20painting%20style%20blended%20with%20modern%20anime%2C%20ethereal%20clouds%20and%20mountains%2C%20golden%20and%20crimson%20color%20palette%2C%20poetic%20atmosphere%2C%20grand%20cinematic%20scale&width=1600&height=800&seq=hero-slide-03&orientation=landscape',
    link: '/article/shaonian-ge-xing-dajieju',
  },
];